/**
 * Health Check Call Source Enum
 * Tracks the origin of health check calls (test calls vs scheduled calls)
 */
export enum HcCallSource {
  TEST_CALL = 'HcCallSource.test_call', // Manual "Call Now" button click
  SCHEDULED = 'HcCallSource.scheduled' // Automatic scheduled call from cron job
}

